import { ReactElement} from "react";
import bgBenefits from "../../assets/images&icons/BackgroundBenefitsAboutUs.jpg";
import "./AboutUs.css";
import LayoutForBenefits from "./components/LayoutForBenefits";


export default function Benefits(): ReactElement {
  return (
      <div className="w-full">

        <LayoutForBenefits
          headerBackgroundImage={bgBenefits}
          title="Benefits of Membership"
          breadcrumbItems={[]}
        >
          <>
            {/* Benefits Content Section */}
            <div className="about-us-page-content py-4 xxs:py-5 xs:py-6 sm:py-8 md:py-10 lg:py-[40px]">
              {/* Main Title */}
              <h1 className="benefits-title mb-6 xs:mb-7 sm:mb-8 md:mb-[30px] text-left">
                Benefits of Membership
              </h1>

              {/* Collaboration Across Industries Section */}
              <div className="mb-8 xs:mb-9 sm:mb-10 md:mb-12 lg:mb-14">
                <h2 className="benefits-subtitle mb-3 xs:mb-4 sm:mb-[15px] text-left">
                  Collaboration Across Industries
                </h2>
                <p className="benefits-paragraph mb-4 text-left">
                  WSG provides cross industry access to a select few investment banking and accounting firms creating more expansive opportunities to service clients. Through seamless collaboration and continual innovation, WSG delivers authentic association of global expertise with highest quality and value for clients.
                </p>
              </div>

              {/* Distinguished Select Membership Section */}
              <div className="mb-8 xs:mb-9 sm:mb-10 md:mb-12 lg:mb-14">
                <h2 className="benefits-subtitle mb-3 xs:mb-4 sm:mb-[15px] text-left">
                  Distinguished Select Membership
                </h2>
                <p className="benefits-paragraph mb-4 text-left">
                  World Services Group is comprised of over 120 prominent firms representing multinational clients worldwide. Members act in over 150 jurisdictions with over 23,000 professionals globally.
                </p>
                <p className="benefits-paragraph mb-4 text-left">
                  WSG members have an established record of standing and client success. Only firms of the highest quality principles, recognized expertise and excellent client service are given the opportunity to be considered. Firm membership is subject to review across multiple leadership channels and is selected based on strict objective standards established by the Board of Directors.
                </p>
              </div>

              {/* Proprietary Solutions Platform Section */}
              <div className="mb-8 xs:mb-9 sm:mb-10 md:mb-12 lg:mb-14">
                <h2 className="benefits-subtitle mb-3 xs:mb-4 sm:mb-[15px] text-left">
                  Proprietary Solutions Platform
                </h2>
                <p className="benefits-paragraph mb-4 text-left">
                  The WSG proprietary solutions platform harnesses the strength of the network and the power of technology to help members stay competitive and exceed client expectations in rapidly changing environments. The platform is built exclusively by and for WSG members allowing for ease of adaptability to industry and client needs.
                </p>
                <p className="benefits-paragraph mb-4 text-left">
                  This exclusive approach enables global expertise powered by seamless collaboration and innovation to compete today and into the future.
                </p>
              </div>

              {/* Knowledge Exchange and Networking Section */}
              <div className="mb-0 xs:mb-1 sm:mb-2">
                <h2 className="benefits-subtitle mb-3 xs:mb-4 sm:mb-[15px] text-left">
                  Knowledge Exchange and Networking
                </h2>
                <p className="benefits-paragraph !mb-0 text-left">
                  WSG members have unlimited opportunities to collaborate, share industry and market expertise and form powerful business relationships to best service clients. Through seamless collaboration and continual innovation, WSG delivers authentic association of global expertise both digitally and through real interactive relationships that deliver the highest quality and value for clients.
                </p>
              </div>
            </div>
          </>
        </LayoutForBenefits>
      </div>
  );
}
